<template>
  <span>{{text}}</span>
</template>

<script>

import ImageViewer from "@/components/img/ImageViewer";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";
import DynamicEntity from "@/components/forms/DynamicEntity";
import ActivityManager from "@/activity/ActivityManager";
import _ from "lodash";
import Vue from "vue";
import prop from "@/server/com/silkplm/engine/audit/path/Prop";
// uwaga, przy zmianie struktury, zmienić w Section.vue/readMore() query selector wyciągający pełny tekst

let counter = 0;

export default {
  name: "DefaultCellTextRenderer",

  created() {

  },

  beforeMount() {

  },
  mounted() {
    this.refresh();
  },

  methods: {
    async refresh(model) {
      model = model ?? this.model;
      if(!this.model || this.model.__pending__){
        this.text = "..";
        return;
      }

      // if (model) {
      //   if (!model.__rowRenderers)
      //     model.__rowRenderers = {};
      //   model.__rowRenderers[this.prop] = this;
      // }

      if (this.column?.toStrFromInstance) {
        let label = this.column.toStrFromInstance(this.model);

        if (label instanceof Promise) {
          this.text = "..";
          label.then(data => {
            this.text = data;
          });
        } else {
          this.text = label;
        }
      } else if (this.column?.toStr) {
        let label = this.column.toStr(this.model[this.prop]);
        if (label instanceof Promise) {
          this.text = "..";
          label.then(data => {
            this.text = data;
          });
        } else {
          //els.push(ColumnService.getData(label));
          this.text = label;
        }
      } else {
        this.text = this.model[this.prop];
      }
    }
  },

  watch: {
    model: function (model) {
      this.refresh(model);
    }
  },
  data: function() { return {
    showGlass: false,
    text: ".."
  }},
  props: ["rowIndex", "prop", "model", "column", "data"]

};
</script>